import { Form } from 'react-bootstrap';
import React from 'react';

export default function DefaultColumnFilter({
  // eslint-disable-next-line react/prop-types
  column: { filterValue, setFilter },
}) {
  return (
    <Form.Control
      size="sm"
      value={filterValue || ''}
      onChange={(e) => {
        setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
    />
  );
}
